export enum Attribute {
  PortName = 'PortCode',
}
